import { render, staticRenderFns } from "./KaKaoPage.vue?vue&type=template&id=1abb150c"
import script from "./KaKaoPage.vue?vue&type=script&lang=js"
export * from "./KaKaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports